// extracted by mini-css-extract-plugin
export default {"LoginForm__activationBannerDescription":"ULHB1Ve7C3"};